import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { Routes } from '../routes';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      matchPath({ path: Routes.TL25.routes.GROUP_STAGE.path }, pathname) ||
      matchPath({ path: Routes.TL25.routes.PLAYOFF.path }, pathname)
    ) {
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
